import React from 'react';
import { SwitchProps } from 'antd';
import { StyledSwitch } from './index.styled';

interface AppSwitchProps extends SwitchProps {
  useSecondaryColor?: boolean;
}

const AppSwitch: React.FC<AppSwitchProps> = ({
  useSecondaryColor = true,
  ...props
}) => {
  return (
    <StyledSwitch
      {...props}
      className={`${props.className || ''} ${useSecondaryColor ? 'secondary-color' : ''}`}
    />
  );
};

export default AppSwitch;
